import { Directive, forwardRef, Input } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  NG_VALIDATORS,
  UntypedFormControl,
} from '@angular/forms';

@Directive({
    selector: '[mustMatchInput]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => MustMatchInputDirective),
            multi: true,
        },
    ],
    standalone: false
})
export class MustMatchInputDirective {
  @Input('mustMatchInput') matchString: String;

  validator: Function;

  constructor() {
    this.validator = validateMatchingString;
  }

  validate(control: UntypedFormControl) {
    return this.matchString ? this.validator(control) : null;
  }
}

export function validateMatchingString(control: UntypedFormControl) {
  return this.matchString === control.value
    ? null
    : {
        mustMatchInput: true,
      };
}

export function matchFormControlValidator(controlName: string) {
  return (control: AbstractControl) =>
    control.value === (control.parent as FormGroup)?.get(controlName)?.value
      ? null
      : { mustMatchInput: true };
}
